import { InjectionToken, Provider } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer, combineReducers } from '@ngrx/store';
import { LoginLogoutActionTypes } from '../../../../core/auth/user-auth/store/actions/login-logout.action';
import { reducer as searchParamsReducer } from '../../../../core/features/store/reducers/search-params.reducer';
import { reducer as searchReducer } from '../../../../core/features/store/reducers/search.reducer';
import { SoldTo } from '../../../../core/model/user.model';
import { CurrenciesActionTypes } from '../../../../core/site-context/store/actions/currencies.action';
import { LanguagesActionTypes } from '../../../../core/site-context/store/actions/languages.action';
import { loaderReducer } from '../../../../core/state/utils/loader';
import { AVAILABLE_SHIP_TOS, DELIVERY_ADDRESS, SOLD_TO, SOLD_TOS, SOLD_TOS_ON_USER_DETAILS, SoldToState } from '../sold-to-state';
import * as fromSoldToActiveReducer from './sold-to-active.reducer';
import * as fromAvailableEntitiesReducer from './sold-to-available-entities.reducer';
import { reducer as availableSearchParamsReducer } from './sold-to-available-search-params.reducer';
import * as fromAvailableShipTosEntitiesReducer from './sold-to-available-ship-tos-entities.reducer';
import { reducer as availableShipTosSearchParamsReducer } from './sold-to-available-ship-tos-search-params.reducer';
import * as fromAvailableShipTosReducer from './sold-to-available-ship-tos.reducer';
import * as fromSoldToAvailableReducer from './sold-to-available.reducer';
import * as fromDeliveryAddressEntitiesReducer from './sold-to-delivery-address-entities.reducer';
import { reducer as deliveryAddressSearchParamsReducer } from './sold-to-delivery-address-search-params.reducer';
import * as fromDeliveryAddressReducer from './sold-to-delivery-address.reducer';

export function getReducers(): ActionReducerMap<SoldToState, any> {
  return {
    active: loaderReducer<SoldTo>(SOLD_TO, fromSoldToActiveReducer.reducer),
    searchParams: searchParamsReducer(SOLD_TOS),
    available: combineReducers({
      search: searchReducer(SOLD_TOS, fromSoldToAvailableReducer.reducer),
      searchParams: availableSearchParamsReducer(SOLD_TOS),
      entities: fromAvailableEntitiesReducer.reducer(SOLD_TOS),
    }),
    availableOnUserDetails: combineReducers({
      search: searchReducer(SOLD_TOS_ON_USER_DETAILS, fromSoldToAvailableReducer.reducer),
      searchParams: availableSearchParamsReducer(SOLD_TOS_ON_USER_DETAILS),
      entities: fromAvailableEntitiesReducer.reducer(SOLD_TOS_ON_USER_DETAILS),
    }),
    deliveryAddresses: combineReducers({
      search: searchReducer(DELIVERY_ADDRESS, fromDeliveryAddressReducer.reducer),
      searchParams: deliveryAddressSearchParamsReducer,
      entities: fromDeliveryAddressEntitiesReducer.reducer,
    }),
    availableShipTos: combineReducers({
      search: searchReducer(AVAILABLE_SHIP_TOS, fromAvailableShipTosReducer.reducer),
      searchParams: availableShipTosSearchParamsReducer,
      entities: fromAvailableShipTosEntitiesReducer.reducer,
    }),
  };
}

export const reducerToken = new InjectionToken<ActionReducerMap<SoldToState>>('SoldToReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export function clearSoldToState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === LoginLogoutActionTypes.Logout) {
      state = undefined;
    }
    if (action.type === CurrenciesActionTypes.CurrencyChange || action.type === LanguagesActionTypes.LanguageChange) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearSoldToState];
